<template>
  <div id="sidebar" class="hide sidebar-menu">
    <div class="ui padded grid">
      <div v-if="rule == 'partner'" class="content">
        <nav>
          <router-link to="/p">
            <i class="home icon"></i> Página Inicial
          </router-link>
        </nav>
      </div>
      <div v-if="rule == 'admin' || rule == 'collaborator'" class="content">
        <div class="ui icon fluid input">
          <i class="search icon"></i>
          <input type="text" placeholder="Pesquisar..." />
        </div>
        <div class="ui divider"></div>
        <nav>
          <router-link to="/">
            <i class="home icon"></i> Página Inicial
          </router-link>
          <span class="section-title">Cadastros</span>
          <router-link to="/users">
            <i class="user icon"></i> Usuários
          </router-link>
          <router-link to="/contracts">
            <i class="file alternative icon"></i> Contratos
          </router-link>
          <router-link to="/plans">
            <i class="clipboard icon"></i> Planos
          </router-link>
          <router-link to="/services">
            <i class="clipboard list icon"></i> Serviços
          </router-link>
          <router-link
            v-if="$allows('partner_category')"
            to="/partner_categories"
          >
            <i class="tags icon"></i> Categorias Parceiros
          </router-link>
          <router-link v-if="$allows('calls')" to="/calls">
            <i class="video icon"></i> Teleatendimento
          </router-link>
          <span class="section-title">Análises</span>
          <router-link to="/ai-chat">
            <i class="comment dots icon"></i> Chat IA
          </router-link>
          <router-link to="/analytics/mrr">
            <i class="file chart pie icon"></i> MRR
          </router-link>
          <span v-if="hasAnyReport" class="section-title">Relatórios</span>
          <router-link v-if="$can('reports_contracts_list')" to="/reports/contract-list">
            <i class="file pdf icon"></i> Listagem de Contratos
          </router-link>
          <router-link
            v-if="$can('reports_procedure_authorizations') && $allows('procedure_authorizations')"
            to="/reports/procedure_authorizations"
          >
            <i class="file pdf icon"></i> Autorizações de procedimentos
          </router-link>
          <router-link v-if="$can('reports_owners')" to="/reports/owners">
            <i class="file pdf icon"></i> Listagem de Titulares
          </router-link>
          <router-link v-if="$can('reports_associates')" to="/reports/associates">
            <i class="file pdf icon"></i> Listagem de Associados
          </router-link>
          <router-link
            v-if="$can('reports_insurance') && $allows('insurance_report')"
            to="/reports/insurance"
          >
            <i class="file pdf icon"></i> Seguro de Vida
          </router-link>
          <router-link v-if="$can('reports_contracts_by_collaborator')" to="/reports/contract-list-by-collaborator">
            <i class="file pdf icon"></i> Listagem de Contratos por Colaborador
          </router-link>
          <router-link v-if="$can('reports_contracts_by_city')" to="/reports/contracts-by-city">
            <i class="file pdf icon"></i> Listagem de Contratos por Cidade
          </router-link>
          <router-link v-if="$can('reports_invoices')" to="/reports/invoices">
            <i class="file pdf icon"></i> Listagem de Parcelas
          </router-link>
          <router-link v-if="$can('reports_billing')" to="/reports/billing">
            <i class="file pdf icon"></i> Cobranças
          </router-link>
          <router-link v-if="$can('reports_receipt')" to="/reports/receipt">
            <i class="file pdf icon"></i> Recebimento
          </router-link>
          <span class="section-title">Importações</span>
          <router-link to="/saae-payments-imports">
            <i class="file import icon"></i> Pagamentos SAAE
          </router-link>
          <span class="section-title">Segurança</span>
          <router-link to="/profiles">
            <i class="users icon"></i> Perfis de Acesso
          </router-link>
          <router-link to="/permissions">
            <i class="lock open icon"></i> Permissões
          </router-link>
          <router-link to="/histories">
            <i class="history icon"></i> Histórico
          </router-link>
          <router-link to="/contracts-audit">
            <i class="search plus icon"></i> Auditoria de contrato
          </router-link>
          <router-link to="/settings">
            <i class="cogs icon"></i> Configurações
          </router-link>
        </nav>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { mapState } from 'vuex';
import Feature from '@/utils/features';
export default {
  computed: {
    ...mapState({
      rule: state => state.user.user.rule
    }),

    hasAnyReport() {
      const reportPermissions = [
        'reports_contracts_list',
        'reports_procedure_authorizations',
        'reports_owners',
        'reports_associates',
        'reports_insurance',
        'reports_contracts_by_collaborator',
        'reports_contracts_by_city',
        'reports_invoices',
        'reports_billing',
        'reports_receipt'
      ];
      return reportPermissions.some(p => this.$can(p));
    }
  },

  data() {
    return {
      showInsuranceReportMenu: Feature.allows('insurance_report')
    };
  },

  mounted() {
    $('body,html').click(e => {
      const container = $('#sidebar');
      const menu = $('#toogle-menu');

      if (
        !container.is(e.target) &&
        container.has(e.target).length === 0 &&
        !menu.is(e.target) &&
        menu.has(e.target).length === 0
      ) {
        container.addClass('hide');
      }
    });
  },

  methods: {
    toggle() {
      $('#sidebar').toggleClass('hide');
    }
  }
};
</script>

<style lang="css" scoped>
.sidebar-menu {
  margin-top: var(--user-menu-height);
  border-right: 1px solid #e1e4e8;
  z-index: 99;
  padding-right: 0px !important;
  position: fixed !important;
  top: 0;
  bottom: 0;
  /* height: 100%; */
  overflow-y: overflow;
  min-width: 18.75%;
  background-color: white;
  overflow-x: hidden;
  width: inherit;
}

.sidebar-menu .ui.divider {
  /* margin-left: 1rem;
    margin-right: 1rem; */
}

.sidebar-menu .router-link-exact-active {
  font-weight: bold;
}

.sidebar-menu .grid .content {
  width: 100%;
  padding: 1rem;
}

.sidebar-menu h4 {
  padding: 1rem;
  margin: 0px;
}

.sidebar-menu nav a {
  display: block;
  padding: 1rem 0px;
}

.sidebar-menu nav a i {
  font-size: 20px;
  margin-right: 10px;
}

.section-title {
  font-size: 1.2em;
  margin-top: 1em;
  display: block;
}
</style>
